import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=17ac77e9&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=ts"
export * from "./UserSettings.vue?vue&type=script&lang=ts"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=17ac77e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ac77e9",
  null
  
)

export default component.exports